import { FC } from 'react';
import { FilterItemResource, FilterStatusItemType } from '../../../../types/FilterTypes';
import PortfolioStatusSingleSelectDropdown from './single-select-dropdown/PortfolioStatusSingleSelectDropdown';

type Config = {
  options: readonly FilterStatusItemType[];
  value?: FilterStatusItemType;
  onChange: (values: FilterStatusItemType) => void;
  onOpen?: () => void;
  onClose?: () => void;
};

const PortfolioStatusDropdown: FC<Config> = ({ options, value, onChange, onOpen, onClose }) => {
  const isChecked = (item: FilterStatusItemType) => {
    return value?.key === item.key;
  };

  const handleOnChange = (val: FilterItemResource, item: FilterStatusItemType) => {
    onChange({
      ...item,
      subStatuses: val ? [{ ...val }] : null,
    });
  };

  const getSubStatusValue = (item: FilterStatusItemType) => {
    return item.key === value?.key ? (value?.subStatuses ? value?.subStatuses[0] : null) : null;
  };

  return (
    <div data-testid='portfolio-status-dropdown'>
      {options.map((item) => (
        <PortfolioStatusSingleSelectDropdown
          key={item.key}
          item={item}
          onChange={(val) => handleOnChange(val, item)}
          onOpen={onOpen}
          onClose={onClose}
          options={item.subStatuses}
          value={getSubStatusValue(item)}
          checked={isChecked(item)}
        />
      ))}
    </div>
  );
};

export default PortfolioStatusDropdown;
